// extracted by mini-css-extract-plugin
export default {"icon":"wallet-transaction-init-view_icon__StTIB","titleLogin":"wallet-transaction-init-view_titleLogin__qn47B","inputForm":"wallet-transaction-init-view_inputForm__XXtVS"};